import { render, staticRenderFns } from "./HiddenMenus.vue?vue&type=template&id=21f538f3"
import script from "./HiddenMenus.vue?vue&type=script&lang=js"
export * from "./HiddenMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports